import React from 'react'
import queryString from 'query-string'
import {gql} from '@apollo/client'
import {Link, useHistory} from 'react-router-dom'
import {useNotify} from 'hooks/useNotify'
import {useQuery, useMutation} from 'components/Graphql'
import Form, {createRoleValue} from 'settings/roles/Form'
import LoadingPage from 'components/LoadingPage'
import styles from 'settings/roles/Create.scss'

const ROLE = gql`
  query role($roleId: Int!) {
    client {
      id
      role(roleId: $roleId) {
        id
        name
        description
        notificationPermission
        searchTargets {
          id
          targetType
          targetSearchType
          talentSearchSettings {
            id
            targetType
            employmentStatus
            positionId
            employmentTypeId
            occupationId
            officeId
            groupId
          }
        }
        talentDisplaySettings {
          id
          talentDisplaySettingCategoryId
        }
        customEmployeeFieldGroupPermissions {
          id
          customEmployeeFieldGroupId
        }
      }
    }
  }
`

const CREATE_ROLE = gql`
  mutation create_role($input: CreateRoleInput!) {
    createRole(input: $input) {
      client {
        id
        roles {
          id
          name
        }
      }
    }
  }
`

const useCreateRole = () => {
  const notify = useNotify()
  const history = useHistory()
  const [mutation] = useMutation(CREATE_ROLE)
  return async ({
    name,
    description,
    notificationPermission,
    employmentStatuses,
    positionIds,
    employmentTypeIds,
    occupationIds,
    officeSearchType,
    officeIds,
    groupSearchType,
    groupIds,
    defaultCategoryIds,
    customCategoryIds,
  }) => {
    await mutation({
      variables: {
        input: {
          name,
          description,
          notificationPermission,
          employmentStatuses,
          positionIds,
          employmentTypeIds,
          occupationIds,
          officeSearchType,
          officeIds: officeSearchType === 'get_select' ? officeIds.split(',') : [],
          groupSearchType,
          groupIds: groupSearchType === 'get_select' ? groupIds.split(',') : [],
          defaultCategoryIds,
          customCategoryIds,
        },
      },
    })
    notify('権限を作成しました', 'success')
    history.push('/settings/roles/list')
  }
}

const NewForm = () => {
  const createRole = useCreateRole()
  return <Form onSubmit={createRole} />
}

const CopyForm = ({id}) => {
  const {data, loading, error} = useQuery(ROLE, {
    variables: {roleId: parseInt(id)},
    fetchPolicy: 'network-only',
  })
  const createRole = useCreateRole()

  if (loading) {
    return <LoadingPage />
  }
  if (error) {
    return <div />
  }

  const role = data?.client ? {...data.client.role, name: `${data.client.role.name} のコピー`} : null
  return <Form initialValues={createRoleValue(role)} onSubmit={createRole} />
}

const Create = ({location: {search}}) => {
  const {role_id} = queryString.parse(search)
  return (
    <div>
      <div className="l-main-title-wrap">
        <h1 className="m-title-main">閲覧権限設定</h1>
      </div>
      <div className="l-wrap-xxl l-contents-wrap">
        <div className={styles.contentsHead}>
          <div className="l-breadcrumb u-mb20">
            <Link to="/settings" className="l-breadcrumb-link">
              設定
            </Link>
            <Link to="/settings/talent_display" className="l-breadcrumb-link">
              情報公開設定
            </Link>
            <span className="l-breadcrumb-here">閲覧権限設定</span>
          </div>
        </div>
        {role_id ? <CopyForm id={role_id} /> : <NewForm />}
      </div>
    </div>
  )
}

export default Create
